export const setupProfile = {};

export const transactionDetail = {
  taxPaidCountry: {
    value: "",
  },
  taxResCountryOtherThanPak: {
    value: "",
  },
  otherTaxResCountry: {
    value: "",
  },
  taxIdentificationNumber: {
    value: "",
  },
  expTurnoverInAccType: {
    value: "",
  },
  expTurnoverInAccAmount: {
    value: "",
  },
  expectedInvestmentAmount: {
    value: "",
  },
};

export const nomineeDetail = {
  name: {
    value: "nmmmm",
    // type: "Alphabets",
    // limit: 100,
    label: "Name",
  },
  nominee_name: {
    value: "",
    type: "Alphabets",
    // limit: 100,
    label: "Name",
  },
  nominee_cnic: {
    value: "",
    type: "NumericWithHypen",
    limit: 15,
    label: "CNIC No",
  },
  landline_number: { value: "" },
  nominee_cnic_issuance_date: { value: "" },
  relationship: { value: "" },
  nominee_city: { value: "" },
  nominee_mobile_no: { value: "", type: "MobileNumber", limit: 16, label: "Phone" },
  current_residential_address: {
    value: "",
    type: "Alphanumeric",
    limit: 500,
    label: "Address",
  },
  email: { value: "xyz@mail.com", label: "Email" },
};

export const finDetailObj = {
  vehicle_make: { value: "" },
  city: { value: "" },
  vehicle_category: { value: "" },
  vehicle_model: { value: "" , type:"Numeric"},
  vehicle_price: { value: "" , type:"Numeric"},
  financing_amount: { value: "" , type:"Numeric"},
  preferred_insurance_company: { value: "" },
  equity_contribution_option: { value: "" },
  financing_tenure: { value: "" },
};

export const fundDetails = {
  financing_option: { value: "" },
  pricing_option: { value: "" },
};

export const alphabetRegex = (value) => {
  return /^[a-z A-Z]*$/.test(value);
};

export const emailRegex = (value) => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
};

export const limitRegex = (value, min, max) => {
  let regex = new RegExp(`/^.{${min},${max}}$/`);
  let newregex = new RegExp(regex.toString().slice(3, -3));
  return newregex.test(value);
};

export const cnicRegex = (value) => {
  let regex = new RegExp(`^[0-9]{5}-[0-9]{7}-[0-9]$`);
  return regex.test(value);
};

export const mobileNumber = (value) => {
  return /^(\+92|0|92)[0-9]{10}$/.test(value);
};
export const numeric = (value) => {
  return /^(0|[1-9][0-9]*)$/.test(value);
};

export const dateFormat = (unformatDate) => {
  let date = new Date(unformatDate);
  let formatted_date =
    date.getDate().toString().padStart(2, "0") +
    "/" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    date.getFullYear();
  return formatted_date;
};

export const retirementAgeSelect = [
  { label: "60 Years", value: "60" },
  { label: "61 Years", value: "61" },
  { label: "62 Years", value: "62" },
  { label: "63 Years", value: "63" },
  { label: "64 Years", value: "64" },
  { label: "65 Years", value: "65" },
  { label: "66 Years", value: "66" },
  { label: "67 Years", value: "67" },
  { label: "68 Years", value: "68" },
  { label: "69 Years", value: "69" },
  { label: "70 Years", value: "70" },
];

export const finOptions = ["Option 1", "Option 2"];

export const vehicle_category = ["New", "Used"];

export const jsIslamicPension = [
  "Lower Volatile (Islamic - Very Conservative)",
  "Low Volatile (Islamic - Conservative)",
  "Medium Volatile (Islamic - Balanced)",
  "High Volatile (Islamic - Aggressive)",
  "Customized Asset Allocation - Islamic",
];

export const jsIslamicPensionSavingFund = [
  "Lower Volatile (Very Conservative)",
  "Low Volatile (Conservative)",
  "Medium Volatile (Balanced)",
  "High Volatile (Aggressive)",
  "Customized Asset Allocation",
];

export const pricingOptions = ["Pricing Option 1", "Pricing Option 2"];

export const disclaimers = [
  {
    key: "BasicInfo",
    message: [
      "I hereby acknowledge that I have been informed of the general risks of investment, and also confirm that JS Investments Limited, through its authorized representatives and distribution agents, has fully disclosed the specific risk factors associated with investments in JS Pension Fund or JS Islamic Pension Savings Fund to my complete satisfaction. ",
      "",
      "I fully understand that past performance does not necessarily indicate future performance. ",
      "",
      "I also undertake that I am fully aware of the Allocation schemes offered by JS Investments and have selected the Allocation Scheme after fully understanding the risks and returns associated with each of the Allocation schemes as disclosed in the offering document. ",
      "",
      "I hereby acknowledge that I have fully understood all the reference notes, the provisions of the Trust Deed and Offering Document and hereby ratify that the information provided on this Form is correct.",
    ],
    title: "Basic Information Disclaimer",
  },
  {
    key: "RPQ",
    message: [
      "",
      "This RPQ has been filled to the best of my knowledge and I agree that this questionnaire only provides some indication of my risk profile, which may or may not exactly reflect my ability to take risk and/ or risk tolerance level. Moreover, JSIL has provided all the necessary advice about the Fund(s), under its management. I agree that any misleading or inaccurate information provided herein may give wrong outcome of the recommendation made. Further, JSIL will not be held liable for any financial consequences.",
    ],
    title: "RPQ Disclaimer",
  },
  {
    key: "CRS",
    message: [
      "-------------------------Document Upload---------------------------",
      "I hereby ratify that the Documents uploaded are correct and I shall immediately update JS Investments Limited (JSIL) if there is any change in the information.",

      "---------------------Basic Information Disclaimer--------------------",
      "I hereby acknowledge that I have been informed of the general risks of investment, and also confirm that JS Investments Limited, through its authorized representatives and distribution agents, has fully disclosed the specific risk factors associated with investments in JS Pension Fund or JS Islamic Pension Savings Fund to my complete satisfaction. ",
      "I fully understand that past performance does not necessarily indicate future performance. ",
      "I also undertake that I am fully aware of the Allocation schemes offered by JS Investments and have selected the Allocation Scheme after fully understanding the risks and returns associated with each of the Allocation schemes as disclosed in the offering document. ",
      "I hereby acknowledge that I have fully understood all the reference notes, the provisions of the Trust Deed and Offering Document and hereby ratify that the information provided on this Form is correct.",

      "---------------------------------RPQ-----------------------------------",
      "This RPQ has been filled to the best of my knowledge and I agree that this questionnaire only provides some indication of my risk profile, which may or may not exactly reflect my ability to take risk and/ or risk tolerance level. Moreover, JSIL has provided all the necessary advice about the Fund(s), under its management. I agree that any misleading or inaccurate information provided herein may give wrong outcome of the recommendation made. Further, JSIL will not be held liable for any financial consequences.",

      "---------------------------------CRS----------------------------------",
      "I understand that the information supplied by me is covered by the full provisions of the terms and conditions governing the Account Holder’s relationship with JSIL setting out how JSIL may use and share the information supplied by me. ",
      "I acknowledge that the information contained in this form and information regarding the Account Holder and any Reportable Account(s) may be provided to the tax authorities of the country/jurisdiction in which this account(s) is/are maintained and exchanged with tax authorities of another country/jurisdiction or countries/jurisdictions in which the Account Holder may be tax resident pursuant to intergovernmental agreements to exchange financial account information. ",
      "I certify that I am the Account Holder (or am authorized to sign for the Account Holder) of all the account(s) to which this form relates. ",
      "I declare that all statements made in this declaration are, to the best of my knowledge and belief, correct and complete. ",
      "I undertake to advise JSIL within 30 days of any change in circumstances which affects the tax residency status of the individual identified above or causes the information contained herein to become incorrect or incomplete, and to provide JSIL with a suitably updated self-certification and Declaration within 30 days of such change in circumstances.",

      "---------------------------------KYC---------------------------------",
      "I hereby acknowledge that I have been informed of the general risks of investment, and also confirm that JS Investments Limited, through its authorized representatives and distribution agents, has fully disclosed the specific risk factors associated with investments in JS Pension Fund or JS Islamic Pension Savings Fund to my complete satisfaction. ",
      "I fully understand that past performance does not necessarily indicate future performance. ",
      "I also undertake that I am fully aware of the Allocation schemes offered by JS Investments and have selected the Allocation Scheme after fully understanding the risks and returns associated with each of the Allocation schemes as disclosed in the offering document. ",
      "I hereby acknowledge that I have fully understood all the reference notes, the provisions of the Trust Deed and Offering Document and hereby ratify that the information provided on this Form is correct.",

      "---------------------------------FATCA--------------------------------",
      "I hereby confirm the information provided above is true, accurate and complete.",
      "I hereby provide my consent to JS Investments Limited (JSIL) or any of its affiliates to disclose and furnish and share information pertaining to my account to domestic or overseas regulators or tax authorities where necessary to establish our tax liability in any jurisdiction.       ",
      "I also authorize JSIL to deduct withholding tax from my account when required to do so by domestic or overseas regulators or tax authorities or pay out, from my account(s) such amounts as may be required according to applicable laws, regulations, agreements with regulators or authorities and directives. ",
      "I shall indemnify and hold JSIL harmless against any claim, damages, costs, expenses and other direct and/or indirect consequence of disclosing, furnishing and sharing any information with any domestic or overseas regulators or tax authorities. ",
      "I agree and undertake to notify the JSIL within thirty (30) calendar days if there is a change in any information which I have provided above. ",
    ],
    title: "Disclaimers",
  },
  {
    key: "DocUpload",
    message: [
      "I hereby ratify that the Documents uploaded are correct and I shall immediately update JS Investments Limited (JSIL) if there is any change in the information.",
    ],
    title: "Document Upload Disclaimer",
  },
  {
    key: "FATCA",
    message: [
      "I hereby confirm the information provided above is true, accurate and complete.",
      "I hereby provide my consent to JS Investments Limited (JSIL) or any of its affiliates to disclose and furnish and share information pertaining to my account to domestic or overseas regulators or tax authorities where necessary to establish our tax liability in any jurisdiction.       ",
      "I also authorize JSIL to deduct withholding tax from my account when required to do so by domestic or overseas regulators or tax authorities or pay out, from my account(s) such amounts as may be required according to applicable laws, regulations, agreements with regulators or authorities and directives. ",
      "I shall indemnify and hold JSIL harmless against any claim, damages, costs, expenses and other direct and/or indirect consequence of disclosing, furnishing and sharing any information with any domestic or overseas regulators or tax authorities. ",
      "I agree and undertake to notify the JSIL within thirty (30) calendar days if there is a change in any information which I have provided above. ",
    ],
    title: "FATCA Disclaimer",
  },
  {
    key: "KYC",
    message: [
      "I hereby acknowledge that I have been informed of the general risks of investment, and also confirm that JS Investments Limited, through its authorized representatives and distribution agents, has fully disclosed the specific risk factors associated with investments in JS Pension Fund or JS Islamic Pension Savings Fund to my complete satisfaction. ",
      "I fully understand that past performance does not necessarily indicate future performance. ",
      "I also undertake that I am fully aware of the Allocation schemes offered by JS Investments and have selected the Allocation Scheme after fully understanding the risks and returns associated with each of the Allocation schemes as disclosed in the offering document. ",
      "I hereby acknowledge that I have fully understood all the reference notes, the provisions of the Trust Deed and Offering Document and hereby ratify that the information provided on this Form is correct.",
    ],
    title: "KYC Disclaimer",
  },
];

export const defaultValue = { cnic: "", accountNo: "" };

export const vehicleMake = [
  {
    key: "TOYOTA YARIS GLI 1.3 MT",
    value: "TOYOTA YARIS GLI 1.3 MT",
  },
  {
    key: "TOYOTA YARIS ATIV 1.3 MT",
    value: "TOYOTA YARIS ATIV 1.3 MT",
  },
  {
    key: "TOYOTA YARIS 1.3 CVT",
    value: "TOYOTA YARIS 1.3 CVT",
  },
  {
    key: "TOYOTA YARIS ATIV 1.3 CVT",
    value: "TOYOTA YARIS ATIV 1.3 CVT",
  },
  {
    key: "TOYOTA ALTIS X CVT 1.8",
    value: "TOYOTA ALTIS X CVT 1.8",
  },
  {
    key: "TOYOTA YARIS ATIV X 1.5 MT",
    value: "TOYOTA YARIS ATIV X 1.5 MT",
  },
  {
    key: "TOYOTA YARIS ATIV X 1.5 CVT",
    value: "TOYOTA YARIS ATIV X 1.5 CVT",
  },
  {
    key: "TOYOTA ALTIS X MT 1.6",
    value: "TOYOTA ALTIS X MT 1.6",
  },
  {
    key: "TOYOTA ALTIS X AT 1.6",
    value: "TOYOTA ALTIS X AT 1.6",
  },
  {
    key: "TOYOTA ALTIS X AT 1.6 SE",
    value: "TOYOTA ALTIS X AT 1.6 SE",
  },
  {
    key: "TOYOTA ALTIS X CVT 1.8",
    value: "TOYOTA ALTIS X CVT 1.8",
  },
  {
    key: "TOYOTA ALTIS X GRANDE CVT 1.8 (BEIGE INTERIOR)",
    value: "TOYOTA ALTIS X GRANDE CVT 1.8 (BEIGE INTERIOR)",
  },
  {
    key: "TOYOTA ALTIS X GRANDE CVT 1.8 (BLACK INTERIOR)",
    value: "TOYOTA ALTIS X GRANDE CVT 1.8 (BLACK INTERIOR)",
  },
  {
    key: "TOYOTA FORTUNER 4X2 AT 2.7L STD G (PETROL)",
    value: "TOYOTA FORTUNER 4X2 AT 2.7L STD G (PETROL)",
  },
  {
    key: "TOYOTA FORTUNER 4X4 AT 2.7L HI V (PETROL)",
    value: "TOYOTA FORTUNER 4X4 AT 2.7L HI V (PETROL)",
  },
  {
    key: "TOYOTA FORTUNER 4X4 AT 2.8L SIGMA (DIESEL)",
    value: "TOYOTA FORTUNER 4X4 AT 2.8L SIGMA (DIESEL)",
  },
  {
    key: "TOYOTA FORTUNER LEGENDER",
    value: "TOYOTA FORTUNER LEGENDER",
  },
  {
    key: "TOYOTA REVO G MT",
    value: "TOYOTA REVO G MT",
  },
  {
    key: "TOYOTA REVO G AT",
    value: "TOYOTA REVO G AT",
  },
  {
    key: "TOYOTA REVO V AT",
    value: "TOYOTA REVO V AT",
  },
  {
    key: "TOYOTA REVO ROCCO",
    value: "TOYOTA REVO ROCCO",
  },
  {
    key: "HONDA CITY 1.2L MT",
    value: "HONDA CITY 1.2L MT",
  },
  {
    key: "HONDA CITY 1.2L CVT",
    value: "HONDA CITY 1.2L CVT",
  },
  {
    key: "HONDA CITY 1.5L CVT",
    value: "HONDA CITY 1.5L CVT",
  },
  {
    key: "HONDA CITY ASPIRE 1.5 MT",
    value: "HONDA CITY ASPIRE 1.5 MT",
  },
  {
    key: "HONDA CITY ASPIRE 1.5 CVT",
    value: "HONDA CITY ASPIRE 1.5 CVT",
  },
  {
    key: "HONDA BR-V I-VTEC S",
    value: "HONDA BR-V I-VTEC S",
  },
  {
    key: "HONDA CIVIC 1.5L TURBO M-CVT",
    value: "HONDA CIVIC 1.5L TURBO M-CVT",
  },
  {
    key: "HONDA CIVIC ORIEL 1.5L TURBO M-CVT",
    value: "HONDA CIVIC ORIEL 1.5L TURBO M-CVT",
  },
  {
    key: "HONDA CIVIC RS 1.5L TURBO LL-CVT",
    value: "HONDA CIVIC RS 1.5L TURBO LL-CVT",
  },
  {
    key: "SUZUKI ALTO VX",
    value: "SUZUKI ALTO VX",
  },
  {
    key: "SUZUKI ALTO VXR",
    value: "SUZUKI ALTO VXR",
  },
  {
    key: "SUZUKI ALTO AGS",
    value: "SUZUKI ALTO AGS",
  },
  {
    key: "SUZUKI WAGONR VXR",
    value: "SUZUKI WAGONR VXR",
  },
  {
    key: "SUZUKI WAGONR VXL",
    value: "SUZUKI WAGONR VXL",
  },
  {
    key: "SUZUKI WAGONR AGS",
    value: "SUZUKI WAGONR AGS",
  },
  {
    key: "SUZUKI CULTUS VXR",
    value: "SUZUKI CULTUS VXR",
  },
  {
    key: "SUZUKI CULTUS VXL",
    value: "SUZUKI CULTUS VXL",
  },
  {
    key: "SUZUKI CULTUS AGS",
    value: "SUZUKI CULTUS AGS",
  },
  {
    key: "SUZUKI SWIFT GL M/T",
    value: "SUZUKI SWIFT GL M/T",
  },
  {
    key: "SUZUKI SWIFT GL CVT",
    value: "SUZUKI SWIFT GL CVT",
  },
  {
    key: "SUZUKI SWIFT GLX CVT",
    value: "SUZUKI SWIFT GLX CVT",
  },
  {
    key: "SUZUKI BOLAN",
    value: "SUZUKI BOLAN",
  },
  {
    key: "SUZUKI CIAZ 1373 GL/A/T",
    value: "SUZUKI CIAZ 1373 GL/A/T",
  },
  {
    key: "SUZUKI JIMNY",
    value: "SUZUKI JIMNY",
  },
  {
    key: "KIA SPORTAGE ALPHA",
    value: "KIA SPORTAGE ALPHA",
  },
  {
    key: "KIA SPORTAGE FWD",
    value: "KIA SPORTAGE FWD",
  },
  {
    key: "KIA SPORTAGE ALPHA AWD",
    value: "KIA SPORTAGE ALPHA AWD",
  },
  {
    key: "KIA CARNIVAL GLS",
    value: "KIA CARNIVAL GLS",
  },
  {
    key: "KIA CARNIVAL GLS+",
    value: "KIA CARNIVAL GLS+",
  },
  {
    key: "KIA STONIC EX",
    value: "KIA STONIC EX",
  },
  {
    key: "KIA STONIC EX+",
    value: "KIA STONIC EX+",
  },
  {
    key: "KIA SORENTO 2.4 FWD",
    value: "KIA SORENTO 2.4 FWD",
  },
  {
    key: "KIA SORENTO 2.4 AWD",
    value: "KIA SORENTO 2.4 AWD",
  },
  {
    key: "KIA SORENTO 3.5 FWD",
    value: "KIA SORENTO 3.5 FWD",
  },
  {
    key: "KIA PICANTO MT",
    value: "KIA PICANTO MT",
  },
  {
    key: "KIA PICANTO AT",
    value: "KIA PICANTO AT",
  },
  {
    key: "HYUNDAI TUSCON FWD GLS SPORT",
    value: "HYUNDAI TUSCON FWD GLS SPORT",
  },
  {
    key: "HYUNDAI TUSCON AWD ULTIMATE",
    value: "HYUNDAI TUSCON AWD ULTIMATE",
  },
  {
    key: "HYUNDAI ELANTRA 2.0L",
    value: "HYUNDAI ELANTRA 2.0L",
  },
  {
    key: "HYUNDAI SONATA 2.5L",
    value: "HYUNDAI SONATA 2.5L",
  },
  {
    key: "HYUNDAI SONATA 2.0L",
    value: "HYUNDAI SONATA 2.0L",
  },
  {
    key: "FAW -CARRIER",
    value: "FAW -CARRIER",
  },
  {
    key: "FAW - XPV",
    value: "FAW - XPV",
  },
  {
    key: "FAW - V2",
    value: "FAW - V2",
  },
  {
    key: "MG - HS 1.5 TURBO PETROL",
    value: "MG - HS 1.5 TURBO PETROL",
  },
  {
    key: "MG - ZS 1.5 TURBO PETROL",
    value: "MG - ZS 1.5 TURBO PETROL",
  },
  {
    key: "PROTON X70 FWD",
    value: "PROTON X70 FWD",
  },
  {
    key: "PROTON X70 FWD",
    value: "PROTON X70 FWD",
  },
  {
    key: "PROTON SAGA MT",
    value: "PROTON SAGA MT",
  },
  {
    key: "PROTON SAGA AT",
    value: "PROTON SAGA AT",
  },
  {
    key: "PROTON SAGA ACE AT",
    value: "PROTON SAGA ACE AT",
  },
  {
    key: "CHANGAN ALSVIN 1.5L DCT ",
    value: "CHANGAN ALSVIN 1.5L DCT ",
  },
  {
    key: "CHANGAN ALSVIN 1.37L MT",
    value: "CHANGAN ALSVIN 1.37L MT",
  },
  {
    key: "CHANGAN ALSVIN 1.5L DCT LUMIERE",
    value: "CHANGAN ALSVIN 1.5L DCT LUMIERE",
  },
  {
    key: "CHANGAN KARVAAN MPV PLUS",
    value: "CHANGAN KARVAAN MPV PLUS",
  },
  {
    key: "CHANGAN KARVAAN MPV PLUS STANDARD",
    value: "CHANGAN KARVAAN MPV PLUS STANDARD",
  },
  {
    key: "OTHERS",
    value: "OTHERS",
  },
];

export const cities = [
  { key: "Gawadar", value: "Gawadar" },
  {
    key: "Turbat",
    value: "Turbat",
  },
  {
    key: "Quetta",
    value: "Quetta",
  },
  {
    key: "Ormara",
    value: "Ormara",
  },
  {
    key: "Karachi",
    value: "Karachi",
  },
  {
    key: "Khuzdar",
    value: "Khuzdar",
  },
  {
    key: "Zhob",
    value: "Zhob",
  },
  {
    key: "Muslim Bagh",
    value: "Muslim Bagh",
  },
  {
    key: "Loralai",
    value: "Loralai",
  },
  {
    key: "Hyderabad ",
    value: "Hyderabad ",
  },
  {
    key: "Thatta ",
    value: "Thatta ",
  },
  {
    key: "Jamshoro ",
    value: "Jamshoro ",
  },
  {
    key: "Mirpur Khas ",
    value: "Mirpur Khas ",
  },
  {
    key: "Kot Ghulam Muhammad ",
    value: "Kot Ghulam Muhammad ",
  },
  {
    key: "Kunri ",
    value: "Kunri ",
  },
  {
    key: "Tando Allah Yar ",
    value: "Tando Allah Yar ",
  },
  {
    key: "Sultanabad ",
    value: "Sultanabad ",
  },
  {
    key: "Maatli ",
    value: "Maatli ",
  },
  {
    key: "Umer Kot ",
    value: "Umer Kot ",
  },
  {
    key: "Tando Jam ",
    value: "Tando Jam ",
  },
  {
    key: "Mithi ",
    value: "Mithi ",
  },
  {
    key: "Badin ",
    value: "Badin ",
  },
  {
    key: "Tando Muhammad Khan ",
    value: "Tando Muhammad Khan ",
  },
  {
    key: "Sheikh Bhirkio ",
    value: "Sheikh Bhirkio ",
  },
  {
    key: "Digri ",
    value: "Digri ",
  },
  {
    key: "Chambar ",
    value: "Chambar ",
  },
  {
    key: "Khairpur",
    value: "Khairpur",
  },
  {
    key: "Sukkur",
    value: "Sukkur",
  },
  {
    key: "Pano Aqil",
    value: "Pano Aqil",
  },
  {
    key: "Ghotki",
    value: "Ghotki",
  },
  {
    key: "Mirpur Mathelo",
    value: "Mirpur Mathelo",
  },
  {
    key: "Daharki",
    value: "Daharki",
  },
  {
    key: "Moro",
    value: "Moro",
  },
  {
    key: "Naushahro Feroze",
    value: "Naushahro Feroze",
  },
  {
    key: "Bhiria City",
    value: "Bhiria City",
  },
  {
    key: "Sanghar",
    value: "Sanghar",
  },
  {
    key: "Shahdadpur",
    value: "Shahdadpur",
  },
  {
    key: "Nawabshah",
    value: "Nawabshah",
  },
  {
    key: "Larkana",
    value: "Larkana",
  },
  {
    key: "Shahdadkot",
    value: "Shahdadkot",
  },
  {
    key: "Mehar",
    value: "Mehar",
  },
  {
    key: "Sehwan",
    value: "Sehwan",
  },
  {
    key: "Shikarpur",
    value: "Shikarpur",
  },
  {
    key: "Kandhkot",
    value: "Kandhkot",
  },
  {
    key: "Kashmore",
    value: "Kashmore",
  },
  {
    key: "Lahore",
    value: "Lahore",
  },
  {
    key: "Kasur",
    value: "Kasur",
  },
  {
    key: "Okara",
    value: "Okara",
  },
  {
    key: "Depalpur",
    value: "Depalpur",
  },
  {
    key: "Pattoki",
    value: "Pattoki",
  },
  {
    key: "Pak Pattan",
    value: "Pak Pattan",
  },
  {
    key: "Arifwala",
    value: "Arifwala",
  },
  {
    key: "Gujranwala",
    value: "Gujranwala",
  },
  {
    key: "Ghakkhar Mandi",
    value: "Ghakkhar Mandi",
  },
  {
    key: "Kamoki",
    value: "Kamoki",
  },
  {
    key: "Lalamusa",
    value: "Lalamusa",
  },
  {
    key: "Hafizabad",
    value: "Hafizabad",
  },
  {
    key: "Muridke",
    value: "Muridke",
  },
  {
    key: "Sheikhupura",
    value: "Sheikhupura",
  },
  {
    key: "Kharian",
    value: "Kharian",
  },
  {
    key: "Gujrat",
    value: "Gujrat",
  },
  {
    key: "Mandi Bahauddin",
    value: "Mandi Bahauddin",
  },
  {
    key: "Dinga",
    value: "Dinga",
  },
  {
    key: "Gulyana",
    value: "Gulyana",
  },
  {
    key: "Wazirabad",
    value: "Wazirabad",
  },
  {
    key: "Sialkot",
    value: "Sialkot",
  },
  {
    key: "Sambrial",
    value: "Sambrial",
  },
  {
    key: "Gohadpur",
    value: "Gohadpur",
  },
  {
    key: "Ugoki",
    value: "Ugoki",
  },
  {
    key: "Daska",
    value: "Daska",
  },
  {
    key: "Faisalabad",
    value: "Faisalabad",
  },
  {
    key: "Toba Tek Singh",
    value: "Toba Tek Singh",
  },
  {
    key: "Gojra",
    value: "Gojra",
  },
  {
    key: "Sargodha",
    value: "Sargodha",
  },
  {
    key: "Rabwa",
    value: "Rabwa",
  },
  {
    key: "Chiniot",
    value: "Chiniot",
  },
  {
    key: "Multan",
    value: "Multan",
  },
  {
    key: "DG Khan",
    value: "DG Khan",
  },
  {
    key: "Muzaffargarh",
    value: "Muzaffargarh",
  },
  {
    key: "Taunsa",
    value: "Taunsa",
  },
  {
    key: "Kot Addu",
    value: "Kot Addu",
  },
  {
    key: "Bhakkar",
    value: "Bhakkar",
  },
  {
    key: "Layyah",
    value: "Layyah",
  },
  {
    key: "Khanewal",
    value: "Khanewal",
  },
  {
    key: "Burewala",
    value: "Burewala",
  },
  {
    key: "Vehari",
    value: "Vehari",
  },
  {
    key: "Sahiwal",
    value: "Sahiwal",
  },
  {
    key: "Chichawatni",
    value: "Chichawatni",
  },
  {
    key: "Mian Chunnoo",
    value: "Mian Chunnoo",
  },
  {
    key: "Rahimyar Khan",
    value: "Rahimyar Khan",
  },
  {
    key: "Sadiqabad",
    value: "Sadiqabad",
  },
  {
    key: "Khanpur",
    value: "Khanpur",
  },
  {
    key: "Haroonabad",
    value: "Haroonabad",
  },
  {
    key: "Bahawalnagar",
    value: "Bahawalnagar",
  },
  {
    key: "Chistian",
    value: "Chistian",
  },
  {
    key: "Dharanwala",
    value: "Dharanwala",
  },
  {
    key: "Bahawalpur",
    value: "Bahawalpur",
  },
  {
    key: "Lodhran",
    value: "Lodhran",
  },
  {
    key: "Hasilpur",
    value: "Hasilpur",
  },
  {
    key: "Islamabad",
    value: "Islamabad",
  },
  {
    key: "Rawalpindi",
    value: "Rawalpindi",
  },
  {
    key: "Muzaffarabad",
    value: "Muzaffarabad",
  },
  {
    key: "Bagh AJK",
    value: "Bagh AJK",
  },
  {
    key: "Taxila",
    value: "Taxila",
  },
  {
    key: "Attock",
    value: "Attock",
  },
  {
    key: "Chakwal",
    value: "Chakwal",
  },
  {
    key: "Jehlum",
    value: "Jehlum",
  },
  {
    key: "Mirpur Ak",
    value: "Mirpur Ak",
  },
  {
    key: "Chaksawari Ak",
    value: "Chaksawari Ak",
  },
  {
    key: "Jatlan Ak",
    value: "Jatlan Ak",
  },
  {
    key: "Dadyal",
    value: "Dadyal",
  },
  {
    key: "Charroi",
    value: "Charroi",
  },
  {
    key: "Sehensa",
    value: "Sehensa",
  },
  {
    key: "Seri",
    value: "Seri",
  },
  {
    key: "Kotli Ak",
    value: "Kotli Ak",
  },
  {
    key: "Khui Ratta Ak",
    value: "Khui Ratta Ak",
  },
  {
    key: "Naarr",
    value: "Naarr",
  },
  {
    key: "Peshawar",
    value: "Peshawar",
  },
  {
    key: "Shakas",
    value: "Shakas",
  },
  {
    key: "Saleh Khana",
    value: "Saleh Khana",
  },
  {
    key: "DI Khan",
    value: "DI Khan",
  },
  {
    key: "Bannu",
    value: "Bannu",
  },
  {
    key: "Darra Adam Khel",
    value: "Darra Adam Khel",
  },
  {
    key: "Parachinar",
    value: "Parachinar",
  },
  {
    key: "Ghalanai",
    value: "Ghalanai",
  },
  {
    key: "Abbottabad",
    value: "Abbottabad",
  },
  {
    key: "Gilgit",
    value: "Gilgit",
  },
  {
    key: "Skardu",
    value: "Skardu",
  },
  {
    key: "Haripur",
    value: "Haripur",
  },
  {
    key: "Mansehra",
    value: "Mansehra",
  },
  {
    key: "Mingora",
    value: "Mingora",
  },
  {
    key: "Chitral",
    value: "Chitral",
  },
  {
    key: "Nowshera",
    value: "Nowshera",
  },
  {
    key: "Shaidu",
    value: "Shaidu",
  },
  {
    key: "Timergara",
    value: "Timergara",
  },
  {
    key: "Charsadda",
    value: "Charsadda",
  },
  {
    key: "Mardan",
    value: "Mardan",
  },
  {
    key: "Topi",
    value: "Topi",
  },
  {
    key: "Chakdarah",
    value: "Chakdarah",
  },
];


